requirejs.config({
    baseUrl: '/wp-content/plugins/U4SM-adaptor/assets',
    waitSeconds: 30,
    paths: {
        knockout: 'js/support/modules/knockout-module-global',
        "knockout.validation": "js/support/knockout.validation",
        domReady: 'js/support/domReady',
        text: 'js/support/text',
        jquery: 'js/support/modules/jquery-module-global',
        select2: 'js/support/select2.min',
        'sm.portal.utility': 'js/support/modules/sm.portal.utility-global',
        'sm.portal.ui': 'js/support/modules/sm.portal.ui-global',
        'smapi.constants': 'js/support/modules/smapi.constants-global',
        'script-params': 'js/support/modules/script-params',
        moment: 'js/support/moment.min',
        js: 'js/'
    },
    shim: {
        select2: {
            deps: ['jquery'],
            exports: '$.select2'
        },
        "knockout.validation": {
            "deps": ["knockout"]
        }
    }
});
require(['bindings/bindings-register', 'components/component-register', 'domReady!'], function () {});